import { useStore } from '../store'
import { clipKept, totalDuration } from '../lib/ranges'

function fmt(t: number): string {
  const m = Math.floor(t / 60)
  const s = Math.floor(t % 60)
  return `${m}:${s.toString().padStart(2, '0')}`
}

/**
 * Timeline ghép: mỗi clip là một đoạn cạnh nhau (rộng theo thời lượng).
 * Phần giữ = xanh, phần cắt = sọc đỏ. Click để tua tới clip + vị trí tương ứng.
 */
export function Timeline() {
  const clips = useStore((s) => s.clips)
  const activeId = useStore((s) => s.activeClipId)
  const currentTime = useStore((s) => s.currentTime)
  const seekTo = useStore((s) => s.seekTo)

  const totalSource = clips.reduce((a, c) => a + c.duration, 0)
  if (totalSource <= 0) return null

  const editedLen = clips.reduce((a, c) => a + totalDuration(clipKept(c)), 0)
  const removedCount = clips.reduce(
    (a, c) => a + c.words.filter((w) => w.removed).length + c.cuts.length,
    0,
  )

  const onSeek = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect()
    const ratio = (e.clientX - rect.left) / rect.width
    let global = Math.max(0, Math.min(totalSource, ratio * totalSource))
    for (const c of clips) {
      if (global <= c.duration) {
        seekTo(c.id, global)
        return
      }
      global -= c.duration
    }
  }

  let offset = 0

  return (
    <div className="timeline">
      <div className="timeline-meta">
        <span>
          Tổng gốc: <b>{fmt(totalSource)}</b> ({clips.length} clip)
        </span>
        <span className="accent">
          Bản dựng: <b>{fmt(editedLen)}</b>
        </span>
        <span>Đã cắt: {removedCount} từ</span>
      </div>

      <div className="track" onClick={onSeek}>
        {clips.map((c) => {
          const left = (offset / totalSource) * 100
          const width = (c.duration / totalSource) * 100
          const kept = clipKept(c)
          offset += c.duration
          return (
            <div
              key={c.id}
              className={`clip-slot ${c.id === activeId ? 'active' : ''}`}
              style={{ left: `${left}%`, width: `${width}%` }}
              title={c.name}
            >
              {kept.map((r, i) => (
                <div
                  key={i}
                  className="track-kept"
                  style={{
                    left: `${(r.start / c.duration) * 100}%`,
                    width: `${((r.end - r.start) / c.duration) * 100}%`,
                  }}
                />
              ))}
              <span className="clip-label">{c.name}</span>
            </div>
          )
        })}
        <div
          className="playhead"
          style={{
            left: `${(() => {
              let acc = 0
              for (const c of clips) {
                if (c.id === activeId) return ((acc + currentTime) / totalSource) * 100
                acc += c.duration
              }
              return 0
            })()}%`,
          }}
        />
      </div>
    </div>
  )
}
